<!-- prettier-ignore -->

@if(route()){
    <div class="custom-route-contianer">

        <div #timelinePane class="timeline">
            <map-timeline #test></map-timeline>
        </div>
        
        <div class="resizer" #resizer (mousedown)="startResizing($event)"></div>

        <div #mapPane class="map" [ngClass]="{'hide-map' : showTimeline()}">
            <map-custom-route></map-custom-route>
        </div>
    
        <route-footer />
    
    </div>
}
